<template>
    <HomeSectionContainer class="relative bg-accent text-ink-inverse rounded-3xl px-10 py-5 [&>div]:gap-2">
        <template #title>
            <div class="flex gap-6 items-center justify-between md:justify-start">
                <h3 class="display-medium text-ink-inverse">{{ title }}</h3>
                <span class="border-dotted border border-ink-inverse/50 text-ink-inverse text-center rounded-lg px-2 py-1 body-bold title-subsection">3 min</span>
            </div>
        </template>
        <div class="flex flex-col md:flex-row gap-1 justify-between w-full">
            <div class="flex flex-col justify-center items">
                <h3 class="title-body text-ink-inverse">
                    {{ header }}
                </h3>
                <p class="body text-ink-inverse">
                    {{ description }}
                </p>
            </div>
        </div>
        <div class="flex md:justify-start w-full items-end mt-4">
            <BaseButton v-if="hasThreeConversations" theme="secondary" @click="handleWrappedClick">
                Take a peek <i class="bi bi-arrow-right ml-2" aria-hidden="true"></i
            ></BaseButton>
            <BaseButton v-else theme="secondary" @click="openUrl(startChatUrl, { queryParams: { chat_source: CHATSOURCE.HOME_WRAPPED } })"> Start Chat </BaseButton>
        </div>
    </HomeSectionContainer>
</template>

<script setup>
import BaseButton from "~vue/components/BaseButton.vue";
import { openUrl } from "~vue/utils";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { CHATSOURCE } from "~vue/utils/constants.js";
import { logUserInteraction } from "~vue/utils/logUtils";
import { computed, onMounted } from "vue";

import HomeSectionContainer from "./HomeSectionContainer.vue";

const { wrappedUrl, wrappedYear, userConversationCount } = defineProps({
    wrappedUrl: { type: String, default: "/wrapped/" },
    wrappedYear: { type: Number, required: true },
    startChatUrl: { type: String, default: "/coach/" },
    userConversationCount: { type: Number, required: true },
});

const newYear = wrappedYear + 1;

const hasThreeConversations = computed(() => userConversationCount >= 3);

onMounted(() => logUserInteraction(AmplitudeEventNames.HOMEPAGE_WRAPPED_CTA_SHOWN, { has_three_conversations: hasThreeConversations.value }));
const title = computed(() => (hasThreeConversations.value ? "Nadia's Reflections" : `Unlock your ${newYear} plan`));
const header = computed(() => (hasThreeConversations.value ? "Discover 3 things you didn't know about yourself" : "You've started something great"));
const description = computed(() => (hasThreeConversations.value ? "" : `Have 3 conversations with Nadia to unlock your personalized roadmap for ${newYear}.`));

const handleWrappedClick = () => {
    logUserInteraction(AmplitudeEventNames.HOMEPAGE_WRAPPED_CARD_CLICKED);
    openUrl(wrappedUrl);
};
</script>
